import { deviceConstants } from "../actions/constants/deviceContstants"


export const deviceListReducer = (state = {}, action) =>{

    switch (action.type) {
        case deviceConstants.GetAllDevicesRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case deviceConstants.GetAllDevicesSuccess:   
            return {
                isLoading: false,
                isSuccess: true,
                isError: false, 
                list : action.payload
            }
        case deviceConstants.GetAllDevicesFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true
            }

        default : return state
    }

}

export const AssignDeviceReducer = (state = {}, action) =>{

    switch (action.type) {
        case deviceConstants.AssignDeviceToFieldRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case deviceConstants.AssignDeviceToFieldSuccess:   
            return {
                isLoading: false,
                isSuccess: true,
                isError: false, 
                list : action.payload
            }
        case deviceConstants.AssignDeviceToFieldFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                message: action.payload
            }
        case deviceConstants.AssignDeviceToFieldClear:
             return {}; 
        default : return state
    }

}

export const UpdateCredentialsReducer = (state = {}, action) =>{

    switch (action.type) {
        case deviceConstants.UpdateCredentialsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case deviceConstants.UpdateCredentialsSuccess:   
            return {
                isLoading: false,
                isSuccess: true,
                isError: false, 
                list : action.payload
            }
        case deviceConstants.UpdateCredentialsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true
            }
        case deviceConstants.UpdateCredentialsClear:
        return {}; 

        default : return state
    }

}